import { render, staticRenderFns } from "./SuggestionAllowed.vue?vue&type=template&id=5f1ad181&scoped=true"
import script from "./SuggestionAllowed.vue?vue&type=script&lang=js"
export * from "./SuggestionAllowed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1ad181",
  null
  
)

export default component.exports